import { styles } from './InvalidUrlScreen.style';
import { useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { LocalizationContext } from '@context/LocalizationContext';
import { ErrorIcon } from '@icons/ErrorIcon';
import { refineFonts } from '@/Theming/refineFonts';

export default function InvalidUrlScreenComponent() {
	const { ErrorMessage: Text } = useContext(LocalizationContext);

	return (
		<Stack
			paddingInline={{
				xxs: '24px',
				xs: '24px',
				sm: '48px',
				md: '105px',
				lg: '350px',
				xl: '403px',
			}}
			paddingTop={'10%'}
			height={'100%'}
			justifyContent={'center'}
			alignItems={'center'}
			tabIndex={1}
			aria-label={`${Text.MissingShortocdeUrlParamTitle || 'Invalid URL'} ${
				Text.MissingShortocdeUrlParamSubtitle ||
				'The URL appears to be invalid. We recommend that you return to the email/SMS you received and click the provided link.'
			}`}
			data-cy={'pqInvalidUrlScreen'}
			sx={styles.container}
			spacing={3}>
			{/* Icon */}

			<ErrorIcon />
			{/* Leaving this here as an example in case we will want to load up an error icon reactive to the color palette */}
			<Typography sx={{ ...refineFonts.h4Regular }}>
				{Text.MissingShortocdeUrlParamTitle || 'Invalid URL'}
			</Typography>

			{/* Subtitle */}

			<Typography sx={{ ...refineFonts.largeRegular }}>
				{Text.MissingShortocdeUrlParamSubtitle ||
					'The URL appears to be invalid. We recommend that you return to the email/SMS you received and click the provided link.'}
			</Typography>
		</Stack>
	);
}
